import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiscountCode } from '@shared/models/data/DiscountCode';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DiscountCodeService {

  constructor(protected _h: HttpClient) { }

  getDiscountCodes(): Observable<DiscountCode[]> {
    var codes = this._h.get<DiscountCode[]>('api/discountcodes/discount-codes');
    return codes;
  }


  addNewDiscountCode(newDiscountCode: DiscountCode): Observable<any> {
    console.log(newDiscountCode);
    return this._h.post('api/discountcodes/discount-codes', newDiscountCode);
    
  }

  updateDiscountCode(existingDiscountCode: DiscountCode): Observable<any> {
    return this._h.put(`api/discountcodes/discount-codes/${existingDiscountCode.id}`, existingDiscountCode)
  }

  deleteDiscountCode(id: number): Observable<any>{
    return this._h.delete(`api/discountcodes/discount-codes/${id}`);
  }

}
